module.exports = __webpack_public_path__ + "media/images/salespartner/partner-figure01-b5167376e554094bc2a7cd8661536544.svg";